import React, { memo } from 'react';

const WelcomeScreen = () => {
  return (
    <div className="cw-welcome-screen">
      <div className="cw-welcome-inner cw-welcome-enter">
        <h1
          className="welcome-greeting cw-welcome-enter-item"
          style={{ '--enter-delay': '0ms' }}
        >
          What would you like to know about Oracle HCM?
        </h1>
        <p
          className="welcome-subtitle cw-welcome-enter-item"
          style={{ '--enter-delay': '60ms' }}
        >
          Your Oracle HCM workspace is ready.
        </p>
      </div>
    </div>
  );
};

export default memo(WelcomeScreen);
